export const CustomersTableColumns = [
    { id: "name",           labelEn: "Name",          labelAr: "الاسم",         align: "left",   sortable: true },
    { id: "email",          labelEn: "Email",         labelAr: "البريد",        align: "left",   sortable: false },
    { id: "phone",          labelEn: "Phone",         labelAr: "الهاتف",        align: "left",   sortable: false },
    { id: "orders_count",   labelEn: "Orders",        labelAr: "الطلبات",       align: "center", sortable: true },
    { id: "total_spent",    labelEn: "Total Spent",   labelAr: "إجمالي الإنفاق", align: "center", sortable: true },
    { id: "status",         labelEn: "Status",        labelAr: "الحالة",        align: "center", sortable: false },
    { id: "created_at",     labelEn: "Joined",        labelAr: "التسجيل",       align: "center", sortable: true },
];
